import { Injectable, computed, inject } from '@angular/core';
import { SessionService } from './session';

/**
 * Who may open Ask Tawtheiq.
 *
 * Ask Tawtheiq is for internal users only (TAW-765). External users — accounts invited from
 * outside the enterprise — still see the button on every surface (top bar, mobile sidebar,
 * side drawer, full page) but it is disabled and cannot be opened.
 *
 * This is a UI courtesy, not the boundary: the backend refuses external users at the hub
 * connect and on every conversation endpoint, so a direct URL, a deep link, or a saved
 * conversation is turned away server-side regardless of what the client does.
 */
@Injectable({
  providedIn: 'root',
})
export class AskTawtheiqAccessService {
  private sessionService = inject(SessionService);

  /** True for internal users; false for accounts flagged external in the system. */
  readonly canUse = computed(() => !this.sessionService.currentUser()?.isExternal);

  /**
   * i18n key for the entry-point button's tooltip: the feature name when it can be opened,
   * the reason when it cannot — so a disabled button explains itself.
   */
  readonly tooltipKey = computed(() =>
    this.canUse() ? 'Ask Tawtheiq' : 'copilot.internalOnly',
  );
}
